var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFlatfinder)?_c('Flatfinder',{staticClass:"kpb-flatfinder",attrs:{"value":_vm.data.flatfinders,"properties":_vm.properties,"suggested":_vm.$path('suggestedFlatfinder', _vm.data)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }